import { ChevronDown } from "lucide-react";

export const HeroSection = ({ onBookingClick }) => {
  const scrollToAbout = () => {
    const element = document.querySelector("#about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="hero-section relative min-h-screen"
    >
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster="/hero-poster.jpg"
        aria-hidden="true"
        data-testid="hero-video"
      >
        <source src="/hero-water.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="hero-overlay" aria-hidden="true" />

      {/* Content */}
      <div className="hero-content px-6">
        <p
          className="text-white/80 text-sm md:text-base tracking-[0.3em] uppercase mb-6 fade-up"
          data-testid="hero-tagline"
        >
          Premium Beauty Salon in Klosters
        </p>

        <h1
          className="font-playfair text-white hero-title leading-tight mb-6 fade-up fade-up-delay-1"
          data-testid="hero-title"
        >
          Entdecken Sie
          <br />
          <span className="italic">Ihre Schönheit</span>
        </h1>

        <p
          className="text-white/90 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed fade-up fade-up-delay-2"
          data-testid="hero-subtitle"
        >
          Erleben Sie luxuriöse Behandlungen in entspannter Atmosphäre.
          Ihr Wohlbefinden ist unsere Leidenschaft.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 fade-up fade-up-delay-3">
          <button
            onClick={onBookingClick}
            data-testid="hero-booking-btn"
            className="bg-white text-[#1A1A1A] px-8 py-4 rounded-full text-sm tracking-[0.15em] uppercase font-medium transition-all duration-300 hover:bg-white/90 hover:transform hover:-translate-y-1 hover:shadow-lg btn-scale"
          >
            Termin buchen
          </button>
          <button
            onClick={scrollToAbout}
            data-testid="hero-learn-more-btn"
            className="text-white px-8 py-4 rounded-full text-sm tracking-[0.15em] uppercase font-medium border border-white/50 transition-all duration-300 hover:bg-white/10 btn-scale"
          >
            Mehr erfahren
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 hover:text-white transition-colors duration-300 flex flex-col items-center gap-2"
        aria-label="Nach unten scrollen"
        data-testid="scroll-indicator"
      >
        <span className="text-xs tracking-[0.2em] uppercase">Scroll</span>
        <ChevronDown size={20} className="animate-bounce" />
      </button>
    </section>
  );
};
